import type { AnniversaryIcon } from "@couples/shared";

import { anniversaryIconComponentOf } from "../lib/schedule/anniversaryIcons";
import { useCloseOnBack } from "../lib/useCloseOnBack";

interface Props {
  title: string;
  suffix: string;
  icon: AnniversaryIcon;
  onClose: () => void;
}

/** 記念日当日、その日はじめて予定画面を開いたときに1回だけ出す告知モーダル */
export default function AnniversaryModal({ title, suffix, icon, onClose }: Props) {
  useCloseOnBack(onClose);
  const Icon = anniversaryIconComponentOf(icon);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-70 flex items-center justify-center bg-black/40 p-6"
    >
      <button type="button" aria-label="閉じる" className="absolute inset-0" onClick={onClose} />

      <div className="relative flex w-full max-w-xs flex-col items-center gap-3 rounded-2xl bg-gradient-to-br from-white to-[var(--color-gold)]/[0.18] p-6 text-center shadow-xl ring-1 ring-[var(--color-gold)]/35">
        <span className="flex size-14 items-center justify-center rounded-full bg-[var(--color-gold)]/15">
          <Icon className="size-7 text-[var(--color-plum)]" aria-hidden />
        </span>
        <p className="text-lg font-bold">記念日です!</p>
        <p className="text-sm text-[var(--color-ink)]">
          {title}
          <span className="ml-1 text-[var(--color-sub)]">({suffix})</span>
        </p>
        <button
          type="button"
          autoFocus
          onClick={onClose}
          className="mt-1 rounded-full bg-[var(--color-teal)] px-6 py-2 text-sm font-semibold text-white"
        >
          わーい
        </button>
      </div>
    </div>
  );
}
